module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Text/H2-14892cf09ed7d821af40d73dd5db0476.svg";